// extracted by mini-css-extract-plugin
module.exports = {"leaderboard":"leaderboard_leaderboard__2UMVV","user":"leaderboard_user__T2_z9"};